<template>
  <div class="status-banner" :class="`status-banner--${type}`">
    <div v-if="icon" class="status-banner__icon">
      <div :class="`${icon}`"></div>
    </div>
    <div class="status-banner__content">
      <div v-if="title || $slots.title" class="status-banner__content_title">
        <slot name="title">
          {{ title }}
        </slot>
      </div>
      <div
        v-if="subtitle || $slots.subtitle"
        class="status-banner__content_subtitle"
      >
        <slot name="subtitle">
          <span v-html="subtitle"></span>
        </slot>
      </div>
    </div>
    <div v-if="amount || $slots.amount" class="status-banner__amount">
      <slot name="amount">
        {{ amount }}
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "neutral",
    },
    icon: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: "",
    },
    amount: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.status-banner {
  padding: 13px 15px;
  display: flex;
  align-items: center;

  &--positive {
    color: white;
    background-color: $colorLightGreen;
  }

  &--neutral {
    background-color: white;

    .status-banner__content_subtitle {
      color: #a8a8a8;
    }
  }

  &--negative {
    color: white;
    background-color: black;
  }

  &__icon {
    align-self: flex-start;
    margin-right: 12px;
  }

  &__content {
    text-align: left;
    flex: 1;

    &_title {
      margin-bottom: 4px;
      font-family: Roboto-Bold;
      font-size: 17px;
      line-height: 20px;
    }

    &_subtitle {
      font-size: 12px;
      line-height: 14px;
    }
  }

  &__amount {
    font-family: Roboto-Bold;
    font-size: 17px;
    line-height: 20px;
  }
}
</style>
